module.exports = "<div class=\"inmar-portal-spinner-container\">\r\n  <div  class=\"inmar-portal-spinner\"></div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/app/components/spinner/spinner.component.html
// module id = ../../../../../src/app/components/spinner/spinner.component.html
// module chunks = main